// extracted by mini-css-extract-plugin
module.exports = {"text":"mobileHeader_text__edVdr"};